<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div [formGroup]="group">
  <p-select
    [dropdownDirection]="'auto'"
    [filter]="this.mode === DynamicBasicSelectMode.SEARCH"
    [label]="model.label ?? undefined"
    [message]="
      model.required && model.errorMessages?.required ? model.errorMessages.required : ('signup.generic.form.requiredField' | translate)
    "
    [state]="control && control.invalid && control.touched ? 'error' : 'none'"
    id="{{ model.id }}"
    [formControlName]="model.id"
    [name]="model.id"
    [required]="model.required"
    [tabindex]="safeTabIndex"
  >
    @for (option of this.modelOptions; track option) {
      <p-select-option [value]="option.value" [disabled]="option.disabled">
        {{ option.label }}
      </p-select-option>
    }
  </p-select>
</div>
